import React from 'react';
import { useMetaPixel } from '../../hooks/useMetaPixel';
interface CTAButtonProps {
  children: ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  variant = 'primary',
  href = '#'
}: CTAButtonProps) {
  const {
    trackCheckout
  } = useMetaPixel();
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    trackCheckout();
    // If it's just a hash link, let it scroll naturally or handle custom routing if needed
    if (href === '#') {
      e.preventDefault();
      // Smooth scroll to top or specific section if needed, for now just track
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }
  };
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-xl transition-all duration-300 transform hover:-translate-y-1 shadow-warm hover:shadow-gold w-full sm:w-auto text-center';
  const variants = {
    primary: 'bg-gold text-chocolate hover:bg-gold-light border-2 border-gold',
    secondary: 'bg-transparent text-gold border-2 border-gold hover:bg-gold/10'
  };
  return <a href={href} onClick={handleClick} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-358">
      {children}
    </a>;
}